import { isEqual } from 'lodash';
import { handleMultiHeaderClick } from './handleMultiHeaderClick';
import { handleMultiAddOption, handleMultiRemoveOption } from './handleMultiOptions';
export var handleRowClicked = function (_a) {
    var closeListOnSelect = _a.closeListOnSelect, closeMenu = _a.closeMenu, handleInputOnSearch = _a.handleInputOnSearch, handleOnChange = _a.handleOnChange, index = _a.index, isMulti = _a.isMulti, inputValue = _a.inputValue, persistentSearch = _a.persistentSearch, options = _a.options, setListDataArraySwitch = _a.setListDataArraySwitch, setFilterTyping = _a.setFilterTyping, setInputValue = _a.setInputValue, setPersistedInputValue = _a.setPersistedInputValue, searchable = _a.searchable, textInputRef = _a.textInputRef, value = _a.value, objToRemove = _a.objToRemove;
    var rowOption = options[index] || objToRemove;
    var headerGroupItems = [];
    // refocus input on click
    var refocusInput = function () {
        if (textInputRef.current) {
            var inputValueLength = inputValue.length;
            textInputRef.current.focus();
            textInputRef.current.setSelectionRange(inputValueLength, inputValueLength);
        }
    };
    /** dont do anything if you clicked a header in single mode, or is disabled */
    if (((rowOption === null || rowOption === void 0 ? void 0 : rowOption.header) && !isMulti) || (rowOption === null || rowOption === void 0 ? void 0 : rowOption.disabled)) {
        refocusInput();
        return;
    }
    /** if you click on a header row, get those grouped options minus the disabled options,
      changing to for loop for speed
    */
    if (rowOption === null || rowOption === void 0 ? void 0 : rowOption.header) {
        var headerGroupItemsTemp = [];
        for (var i = 0; i < options.length; i++) {
            if (!options[i].disabled && !options[i].header && options[i].groupId === rowOption.groupId) {
                headerGroupItemsTemp.push(options[i]);
            }
        }
        headerGroupItems = headerGroupItemsTemp;
    }
    /** if multi select */
    if (isMulti && Array.isArray(value)) {
        /** if you clicked the header */
        if (headerGroupItems.length) {
            handleMultiHeaderClick({ headerGroupItems: headerGroupItems, rowOption: rowOption, value: value, handleOnChange: handleOnChange });
        }
        else if (value.some(function (opt) { return isEqual(opt, rowOption); })) {
            /** optionSelected that not a header, if selected/is in value array, remove it, else add it */
            handleMultiRemoveOption({ rowOption: rowOption, value: value, handleOnChange: handleOnChange });
        }
        else {
            handleMultiAddOption({ rowOption: rowOption, value: value, handleOnChange: handleOnChange });
        }
        if (!persistentSearch) {
            setInputValue('');
        }
        if (persistentSearch && inputValue) {
            setPersistedInputValue(inputValue);
        }
    }
    else if (isEqual(value, rowOption)) {
        /** if single select */
        handleOnChange(undefined);
        handleInputOnSearch('');
    }
    else {
        handleOnChange(rowOption);
    }
    refocusInput();
    if (closeListOnSelect || !isMulti) {
        closeMenu();
    }
    // if we click, we update the value, set to false so that the focused row doesnt update when the value changes.
    setFilterTyping(false);
    if (searchable) {
        setListDataArraySwitch(true);
    }
};
